<template>
    <div>
        <page-navigate></page-navigate>
        <div :class="[$t('common.requestLang'), $t('common.type')]">
            <div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
                <section class="section1">
                    <img class="section1-messi" src="../assets/image/trade-for-messi/messi.svg" alt="" />
                    <h1 class="pc" v-html="$t('tradeForMessi.在EBC交易赢梅西签名限量球衣PC')"></h1>
                    <h1 class="mobile" v-html="$t('tradeForMessi.在EBC交易赢梅西签名限量球衣Mobile')"></h1>
                    <p class="section1-time">{{ $t('tradeForMessi.活动时间:') }}<br class="mobile" />{{
                        $t('tradeForMessi.2025年3月1日') }}</p>
                    <a href="{$register}" class="btn-go">
                        {{ $t('tradeForMessi.立即参与') }} <span class="iconfont icon-chevron_right"></span></a>
                </section>
                <section class="section2">
                    <img class="messi-no pc" src="../assets/image/trade-for-messi/messi-no.svg" alt="" />
                    <div class="section2-item">
                        <img class="section2-item-img ml-10" src="../assets/image/trade-for-messi/section2-1.png"
                            alt="" />
                        <div class="section2-item-content mr-35">
                            <p class="p1">{{ $t('tradeForMessi.亲笔签名并装裱') }}</p>
                            <h2>{{ $t('tradeForMessi.莱昂内尔·梅西') }}</h2>
                            <h3>{{ $t('tradeForMessi.巴塞罗那官方') }}<br v-if="$t('tradeForMessi.赛季主场球衣')"
                                    class="mobile" />{{ $t('tradeForMessi.赛季主场球衣') }}
                            </h3>
                            <p class="p2">
                                {{ $t('tradeForMessi.这件球衣由梅西于2023年1月28日在巴黎的一场私人签名会上亲笔签名') }}

                            </p>
                        </div>
                    </div>
                    <div class="section2-item">
                        <div class="section2-item-content ml-35">
                            <p class="p1 mt-70">{{ $t('tradeForMessi.亲笔签名') }}</p>
                            <h2>{{ $t('tradeForMessi.莱昂内尔·梅西、') }}<br class="mobile" />{{ $t('tradeForMessi.路易斯·苏亚雷斯')
                                }}</h2>
                            <h3>{{ $t('tradeForMessi.巴萨2016-17赛季主场球衣') }}</h3>
                            <p class="p2" v-html="$t('tradeForMessi.这件球衣由两位传奇球星梅西和苏亚雷斯亲笔签名')">
                            </p>
                        </div>
                        <img class="section2-item-img mr-10" src="../assets/image/trade-for-messi/section2-2.png"
                            alt="" />
                    </div>
                </section>
                <section class="section3">
                    <div class="section3-content">
                        <h2>{{ $t('tradeForMessi.拉明·亚马尔') }}</h2>
                        <h3>{{ $t('tradeForMessi.巴萨2024-25赛季主场球衣') }}</h3>
                        <p class="p2" v-html="$t('tradeForMessi.这件巴萨球衣印有亚马尔的名字和球号')">
                        </p>
                    </div>
                </section>
                <section class="section4">
                    <img class="messi-name pc" src="../assets/image/trade-for-messi/messi-name.svg" alt="" />
                    <img class="messi-name mobile" src="../assets/image/trade-for-messi/messi-name-m.svg" alt="" />
                    <div class="section4-content">
                        <h4 class="mt-0">{{ $t('tradeForMessi.活动时间') }}</h4>
                        <p class="p1">{{ $t('tradeForMessi.2025年3月1日') }}</p>
                        <h4>{{ $t('tradeForMessi.活动规则') }}</h4>
                        <p class="p1" v-html="$t('tradeForMessi.交易量PK')">

                        </p>
                        <p class="p1" v-html="$t('tradeForMessi.入金量PK')">

                        </p>
                        <h4>{{ $t('tradeForMessi.活动条款') }}</h4>
                        <p class="p2" v-for="item in $t('tradeForMessi.list')">{{ item }} </p>

                    </div>
                </section>
            </div>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.section1 {
    height: 600rem;
    background: url("../assets/image/trade-for-messi/bg.jpg");
    background-size: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.section1-messi {
    width: 375rem;
}

.section1 h1 {
    margin-top: 36rem;
    color: #fff;
    font-size: 70rem;
    font-style: normal;
    font-weight: 900;
    line-height: 1em;
    text-align: center;
    padding: 0 100rem;
}

.en .section1 h1 {
    font-size: 56rem;
    line-height: 64rem;
    font-weight: 700;
    text-transform: uppercase;
}

/* .section1 .ebc {
  font-family: Gilroy;
  font-size: 79rem;
  font-weight: 700;
  margin-top: 4rem;
} */

.section1-time {
    margin-top: 36rem;
    color: #fff;
    text-align: center;
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1em;
}

.btn-go {
    margin-top: 54rem;
    display: flex;
    gap: 8rem;
    min-width: 460rem;
    height: 56rem;
    justify-content: center;
    align-items: center;
    border-radius: 8rem;
    background: #f4d84d;

    color: #152456;
    font-size: 20rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1em;
    transition: all 0.3s;
    padding: 0 60rem;
}

.btn-go:hover {
    background: #d7b81b;
    color: #152456;
}

.btn-go .icon-chevron_right {
    margin-top: 2rem;
    font-size: 18rem;
}

.section2 {
    position: relative;
    height: 1147rem;
    background-image: url("../assets/image/trade-for-messi/bg2.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    padding: 110rem 0;
}

.messi-no {
    position: absolute;
    right: 350rem;
    top: 134rem;
    width: 175rem;
    height: 148rem;
}

.ar .messi-no {
    right: unset;
    left: 350rem;
}

.section2-item {
    margin: 0 auto;
    width: 1440rem;
    padding: 0 100rem;
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    gap: 85rem;
}

.section2-item-img {
    width: 579rem;
    height: 487rem;
}

.section2-item-content {
    width: 530rem;
}

.section2-item-content .p1 {
    margin-top: 90rem;
    color: #9f734c;
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 32rem;
}

.en .section2-item-content .p1 {
    font-weight: 600;
    margin-top: 60rem;
}

.section2-item-content h2 {
    margin-top: 40rem;
    color: #232222;
    font-size: 32rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1em;
}

.en .section2-item-content h2 {
    text-transform: uppercase;
}

.section2-item-content h3 {
    margin-top: 24rem;
    color: #232222;
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1em;
}

.en .section2-item-content h3 {
    font-weight: 600;
}

.section2-item-content .p2 {
    margin-top: 36rem;
    color: #6a6967;
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
    /* 175% */
}

.en .section2-item-content .p2 {
    /* font-weight: 500; */
    line-height: 24rem;
}

.mr-10 {
    margin-right: 10rem;
}

.ml-10 {
    margin-left: 10rem;
}

.mr-35 {
    margin-right: 35rem;
}

.ml-35 {
    margin-left: 35rem;
}

.section2-item-content .mt-70 {
    margin-top: 70rem;
}

.section3 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 460rem;
    background-image: url("../assets/image/trade-for-messi/bg3.jpg");
    background-size: cover;
    background-repeat: no-repeat;
}

.section3-content {
    width: 530rem;
    margin-right: 365rem;
}

.ar .section3 {
    justify-content: flex-start;
}

.ar .section3-content {
    margin-right: 340rem;
}

.section3-content h2 {
    margin-top: 40rem;
    color: #fff;
    font-size: 32rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1em;
}

.section3-content h3 {
    margin-top: 24rem;
    color: #fff;
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1em;
}

.en .section3-content h3 {
    font-weight: 600;
}

.section3-content .p2 {
    margin-top: 36rem;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
    /* 175% */
}

.en .section3-content .p2 {
    /* font-weight: 500; */
    line-height: 24rem;
}

.section4 {
    position: relative;
    padding: 0 340rem;
    height: 665rem;
    background-image: url("../assets/image/trade-for-messi/bg4.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
}

.messi-name {
    position: absolute;
    right: 340rem;
    top: 25rem;
    width: 487rem;
    height: 349rem;
}

.ar .messi-name {
    right: unset;
    left: 340rem;
}

.section4-content h4 {
    margin: 40rem 0 20rem 0;
    color: var(--ebc--, #fff);

    font-size: 20rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1em;
}

.section4-content .mt-0 {
    margin-top: 0;
}

.section4-content .p1,
.section4-content .p2 {
    color: rgba(255, 255, 255, 0.7);
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
}

.section4-content .p1 {
    padding-right: 500rem;
}

.en .section4-content .p1,
.en .section4-content .p2 {
    /* font-weight: 500; */
    line-height: 24rem;
}

.section4-content .p2 {
    position: relative;
    padding-left: 16rem;
}

.ar .section4-content .p2 {
    padding-left: 0;
    padding-right: 16rem;
}

.section4-content .p2::before {
    content: "";
    width: 2px;
    height: 2px;
    position: absolute;
    left: calc(8rem - 1px);
    top: calc(13rem - 1px);
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
}

.ar .section4-content .p2::before {
    left: unset;
    right: calc(8rem - 1px);
}

@media (max-width: 996px) {
    .section1 {
        height: auto;
        padding: 162rem 74rem;
    }

    .section1-messi {
        width: 452rem;
        height: 125rem;
    }

    .section1 h1 {
        padding: 0;
        margin-top: 80rem;
        text-align: center;
    }

    .section1 /deep/ .p1 {
        color: #fff;
        font-size: 80rem;
        font-style: normal;
        font-weight: 900;
        line-height: 1em;
    }

    .section1 /deep/ .p2 {
        margin-top: 40rem;
        color: #fff;
        font-size: 120rem;
        font-style: normal;
        font-weight: 900;
        line-height: 1em;
    }

    .section1 /deep/ .p3 {
        margin-top: 30rem;
        color: #fff;
        font-size: 108rem;
        font-style: normal;
        font-weight: 900;
        line-height: 1em;
    }

    .section1-time {
        margin-top: 70rem;
        font-size: 40rem;
        line-height: normal;
    }

    .btn-go {
        height: 90rem;
        font-size: 40rem;
    }

    .en .btn-go {
        font-size: 28rem;
    }

    .btn-go .icon-chevron_right {
        font-size: 36rem;
    }

    .en .btn-go .icon-chevron_right {
        font-size: 28rem;
    }

    .section2 {
        height: auto;
        padding: 136rem 60rem;
        background-image: url("../assets/image/trade-for-messi/bg2_m.jpg");
        background-size: cover;
        background-repeat: no-repeat;
    }

    .section2-item {
        padding: 0;
        flex-direction: column;
        gap: 30rem;
        width: auto;
    }

    .section2-item-img {
        margin: 0;
        width: 630rem;
        height: 530rem;
        order: 1;
    }

    .section2-item-content {
        margin: 0;
        width: auto;
        order: 2;
    }

    .section2-item+.section2-item {
        margin-top: 110rem;
    }

    .section2-item-content .p1 {
        margin: 0;
        font-size: 40rem;
    }

    .en .section2-item-content .p1 {
        line-height: 64rem;
    }

    .section2-item-content h2 {
        margin-top: 38rem;
        font-size: 64rem;
        line-height: normal;
    }

    .section2-item-content h3 {
        margin-top: 4rem;
        font-size: 40rem;
        line-height: 64rem;
    }

    .section2-item-content .p2 {
        margin-top: 49rem;
        font-size: 32rem;
        font-weight: 400;
        line-height: 56rem;
    }

    .en .section2-item-content .p2 {
        line-height: 48rem;
    }

    .section3 {
        height: auto;
        min-height: 1736rem;
        padding: 1062rem 60rem 60rem;
        background-image: url("../assets/image/trade-for-messi/bg3_m.jpg");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .ar .section3-content,
    .section3-content {
        width: auto;
        margin: 0;
    }

    .section3-content h2 {
        margin: 0;
        font-size: 64rem;
        line-height: normal;
    }

    .section3-content h3 {
        margin-top: 4rem;
        font-size: 40rem;
        line-height: 64rem;
    }

    .section3-content .p2 {
        margin-top: 49rem;
        font-size: 32rem;
        font-weight: 400;
        line-height: 56rem;
    }

    .en .section3-content .p2 {
        line-height: 48rem;
    }

    .section4 {
        padding: 0 60rem 120rem;
        flex-direction: column;
        height: auto;
        background-image: url("../assets/image/trade-for-messi/bg4_m.jpg");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .ar .messi-name,
    .messi-name {
        position: relative;
        right: unset;
        top: unset;
        left: unset;
        width: 608rem;
        height: 527rem;
    }

    .section4-content h4 {
        font-size: 40rem;
    }

    .section4-content .p1,
    .section4-content .p2 {
        font-size: 32rem;
        line-height: 56rem;
    }

    .section4-content .p1 {
        padding-right: 0;
    }

    .en .section4-content .p1,
    .en .section4-content .p2 {
        line-height: 48rem;
    }

    .section4-content .p2 {
        padding-left: 32rem;
    }

    .section4-content .p2::before {
        width: 4px;
        height: 4px;
        left: calc(16rem - 2px);
        top: calc(28rem - 2px);
    }

    .ar .section4-content .p2 {
        padding-right: 32rem;
    }

    .ar .section4-content .p2::before {
        width: 4px;
        height: 4px;
        right: calc(16rem - 2px);
        top: calc(28rem - 2px);
    }
}
</style>